import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { AuthGuard } from './shared/_helper/auth-guard.service';



const routes: Routes = [


  {
    path: 'login',
    component: LoginComponent
  },


  {
    path: '',
    component: ContentComponent,
    canActivate: [AuthGuard],
    //children: content
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: 'violation',
    component: ContentComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./violation-pages/violation-pages.module').then(m => m.ViolationPagesModule)
  },
  {
    path: 'inspection',
    component: ContentComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./inspection-pages/inspection-pages.module').then(m => m.InspectionPagesModule)
  },
  {
    path: 'adjudication',
    component: ContentComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./adjudication/adjudication.module').then(m => m.AdjudicationModule)
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule)
  },

  // {
  //   path: 'investigation',
  //   canActivate: [AuthGuard],
  //   loadChildren: () => import('./pages/concealment/investigation/investigation.module').then(m => m.InvestigationModule)
  // },

  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
   // relativeLinkResolution: 'legacy'
  })],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
